import request from '@/utils/http.js';
import env from '@/request/env';
// import contextServer from '@/domain/common/context.server.js';

/**
 * @function attention 获取在线商品列表
 * @param {*} data
 */
const queryGoodsList = params => {
  const url = env.qa === 'v3' ? '/v3/interacts/goods/get-on-sale-goods-list' : '';
  return request({
    url: url,
    method: 'GET',
    params: params
  });
};
const queryGoodsListJson = params => {
  return request({
    url: params.url,
    method: 'GET',
    params: params
  });
};
// 观看端_查看活动下某个商品详情
const getGoodDetail = params => {
  const url = env.qa === 'v3' ? '/v3/interacts/goods/watch-get-goods-details' : '';
  return request({
    url: url,
    method: 'GET',
    params: params
  });
};

/**
 * 获取活动预售商品
 * http://yapi.vhall.domain/project/1285/interface/api/61831
 * @param params
 * @returns {*}
 */
const getPreSaleGoods = params => {
  const url = env.qa === 'v3' ? '/v3/goods/webinar/get-pre-sale-goods' : '';
  return request({
    url: url,
    method: 'GET',
    params: params
  });
};

/**
 * 店铺排行榜
 * http://yapi.vhall.domain/project/102/interface/api/61862
 * @param params
 * {
 *   webinar_id
 * }
 * @returns {*}
 */
const getShopRankList = params => {
  const url = env.qa === 'v3' ? '/v3/commons/shop-ranking/index' : '';
  return request({
    url: url,
    method: 'GET',
    params: params
  });
};

// 获取商品其他设置
const getProductsOtherInfo = params => {
  const url = env.qa === 'v3' ? '/v3/goods/webinar-setting/get-info' : '';
  return request({
    url: url,
    method: 'GET',
    params: params
  });
};

export default {
  queryGoodsList,
  queryGoodsListJson,
  getGoodDetail,
  getPreSaleGoods,
  getShopRankList,
  getProductsOtherInfo
};
